import { defineRoute } from '../defineRoute';

export type MyFavoriteListingsRouteParams = {
  // ...
};

export type MyFavoriteListingsRouteParamsString = {
  // ...
};

export const MyFavoriteListings = defineRoute<
  MyFavoriteListingsRouteParams,
  MyFavoriteListingsRouteParamsString
>({
  pathname: '/my-favorites/rooms',
  nlPathname: '/mijn-favorieten/kamers',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
